module.exports = __WEBPACK_EXTERNAL_MODULE_0__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Handsontable","commonjs2":"handsontable","commonjs":"handsontable","amd":"handsontable","umd":"handsontable"}
// module id = 0
// module chunks = 0